import _ from "lodash";

export default {
    data() {
        return {
            total  : {
                total: 0.0
            },
            items  : {},
            options: {
                itemsPerPage: this.$store.state.itemsPerPage,
            },
            loading: false,
            headers: [
                {text: 'ref', value: 'ref', sortable: false},
                {text: 'category', value: 'category.name', sortable: false},
                {text: 'warehouse', value: 'warehouse.name', sortable: false},
                {text: 'amount', value: 'amount', sortable: false},
                {text: 'note', value: 'note', sortable: false},
                {text: 'date', value: 'income_date', sortable: false},
                {text: 'action', value: 'action', sortable: false},
            ],
        }
    },
    watch  : {
        options: {
            deep: true,
            handler() {
                this.loading = true
                this.getData()
            }
        }
    },
    created() {
        axios.get('/api/income/total-sum')
             .then(res => {
                 this.total = res.data.total
             })
    },
    methods: {
        deleteItem(id) {
            if(!confirm("are you sure?")) {
                return false;
            }
            this.loading = true
            axios.delete('/api/income/incomes/' + id)
                 .then(res => {
                     this.getData()
                     this.loading = false
                     Swal.fire({
                                   icon             : res.data.type,
                                   timer            : 3000,
                                   text             : res.data.message,
                                   showCancelButton : false,
                                   showConfirmButton: false
                               })
                 })
        },
        getData: _.debounce(function () {
            this.loading = true
            axios.get('/api/income/incomes', {
                params: this.options
            })
                 .then(res => {
                     this.items   = res.data
                     this.loading = false
                 })
        }, 800),

        getExpenseList(query, callback) {
            axios.get('/api/income/incomes?dropdown=true').then(response => {
                this.incomes = response.data;
                callback(query);
            }).catch(error => {

            })
        },

    }
}